import React, { Component }  from 'react'
import { connect } from 'shalala';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { Guardian } from '@xaamin/guardian';

import { Http } from '../../../../../support';
import { useStore } from '../../../../../store';
import LoadingButton from '../../../../../facturotopia/LoadingButton';

class RecepcionFilesListActions extends Component {
  state = {
    busy: false,
  }

  handleOnDownloadActionClick = async () => {
    this.setState({
      busy: true
    });

    try {
      const params = {
        download: 1,
        from: this.props.pagination.from,
        to: this.props.pagination.to,
        ...this.props.filters,
      }

      const response = await Http.get(`${window.BONJOUR_URL}/api/recepcion/comprobantes`, { responseType: 'blob', params });

      window.downloadFromHttpResponse(response);
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.data?.message || error.message || 'No podemos descargar el reporte'
      });
    } finally {
      this.setState({
        busy: false
      });
    }
  }

  render() {
    const { busy } = this.state;

    return (
      <>
        { Guardian.allows('recepcion.subir.archivo') && (
          <Button as={ Link }
            className="mr-2"
            to="/modulos/recepcion/upload"
          >
            Subir archivo
          </Button>
        )}

        { Guardian.allows('recepcion.descargar.reporte') && (
          <LoadingButton
            variant="secondary"
            loading={ busy }
            onClick={ this.handleOnDownloadActionClick }
          >
            { busy === true ? 'Descargando' : 'Descargar' }
          </LoadingButton>
        )}
      </>
    )
  }
}

const mapState = (state) => {
  return state.modulo.recepcion.list;
}

const mapActions = (actions) => {
  return {};
}

export default connect(useStore, mapState, mapActions)(RecepcionFilesListActions);